import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import { GlobalStateDataContext } from '../context-api/data-provider/GlobalStateDataProvider';
import { canAccessRoute } from '../utils/regBranchRouteAccess';
import { getUrlPath } from '../utils/getUrls';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import CollectionsBookmarkOutlinedIcon from '@mui/icons-material/CollectionsBookmarkOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';

const DashBoard = () => {
  const navigate = useNavigate();

  const { selectedMenuTab, setSelectedMenuTab, regBranchSession } = useContext(GlobalStateDataContext);

  const isTemporaryPassword =
    regBranchSession?.teamInfo?.temporary_password === true ||
    regBranchSession?.teamInfo?.temporary_password === 'true';

  const [tempPasswordAlertDismissed, setTempPasswordAlertDismissed] = useState(false);

  useEffect(() => {
    if (!isTemporaryPassword) {
      setTempPasswordAlertDismissed(false);
    }
  }, [isTemporaryPassword]);

  const showTempPasswordAlert = isTemporaryPassword && !tempPasswordAlertDismissed;

  const checkUrl = getUrlPath() === '/';

  const RedirectPage = async (path) => {
    // if (checkUrl === false) {
    //     await navigate('/')
    // }

    if (path === 'connected-accounts') {
      await navigate('/connectedusers');
    }

    if (path === 'store-management') {
      await navigate('/storemanagement');
    }

    if (path === 'order-management') {
      await navigate('/ordermanagement');
    }

    if (path === 'squads') {
      await navigate('/squads');
    }

    if (path === 'teams') {
      await navigate('/teams');
    }

    if (path === 'storeleads') {
      await navigate('/storeleads');
    }

    if (path === 'zipcodemap') {
      await navigate('/zipcodemap');
    }

    if (path === 'agentproduct') {
      await navigate('/productagent');
    }

    if (path === 'agentlogo') {
      await navigate('/logoagent');
    }

    if (path === 'menuuploadjobs') {
      await navigate('/menuuploadjobs');
    }

    if (path === 'products') {
      await navigate('/products');
    }

    if (path === 'marketinglead') {
      await navigate('/marketinglead');
    }

    if (path === 'adlibrary') {
      await navigate('/adlibrary');
    }

    if (path === 'analytics') {
      await navigate('/analytics');
    }

    if (path === 'server-monitoring') {
      await navigate('/servermonitoring');
    }

    if (path === 'notifications') {
      await navigate('/notifications');
    }
  };

  const BtnStyle = {
    color: 'lightgray',
    margin: '0px 10px 0px 10px',
    width: '120px',
    height: '100px',
    fontSize: '15px',
    fontFamily: 'Inter Regular',
    backgroundColor: 'transparent',
    border: '1px solid lightgray',
    borderRadius: '5px',
    cursor: 'pointer',
  };

  const BtnSelectedStyle = {
    color: '#024CAA',
    margin: '0px 5px 0px 10px',
    fontSize: '15px',
    fontFamily: 'Inter Bold',
    backgroundColor: 'white',
    border: '2px solid #091057',
    borderRadius: '5px',
    // padding: '2px 8px 2px 8px',
    cursor: 'pointer',
    width: '200px',
    height: '100px',
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          maxWidth: '2200px',
          flexDirection: 'column',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {showTempPasswordAlert && (
          <Alert
            severity="warning"
            onClose={() => setTempPasswordAlertDismissed(true)}
            sx={{
              mb: 2.5,
              mt: 1,
              width: '100%',
              maxWidth: 960,
              boxSizing: 'border-box',
              borderRadius: '10px',
              fontFamily: 'Inter Regular',
              bgcolor: '#fffbeb',
              border: '1px solid #fde68a',
              color: '#78350f',
              fontWeight: 500,
              fontSize: '0.875rem',
              '& .MuiAlert-icon': { color: '#d97706' },
              '& .MuiAlert-action .MuiIconButton-root': {
                color: '#d97706',
                '&:hover': { bgcolor: 'rgba(217,119,6,0.08)' },
              },
            }}
          >
            You are using a temporary password. Change it as soon as possible for your account
            security.
          </Alert>
        )}

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            margin: '20px',
          }}
        >
          {canAccessRoute('/storemanagement', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('store-management');
              RedirectPage('store-management');
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <AccountBalanceIcon style={{ color: '#EC8305', fontSize: '30px' }} />
              <div style={{ fontSize: '14px', fontFamily: 'Inter Bold', color: '#091057' }}>
                Store Management
              </div>
              <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: '#024CAA' }}>
                Sub title coming soon..
              </div>
            </div>
          </button>
          )}

          {canAccessRoute('/connectedusers', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('connected-accounts');
              RedirectPage('connected-accounts');
            }}
          >
            {'Connected Accounts'}
          </button>
          )}

          {canAccessRoute('/ordermanagement', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('order-management');
              RedirectPage('order-management');
            }}
          >
            {'View Orders'}
          </button>
          )}

          {canAccessRoute('/products', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              RedirectPage('products');
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Inventory2OutlinedIcon style={{ color: '#EC8305', fontSize: '30px' }} />
              <div style={{ fontSize: '14px', fontFamily: 'Inter Bold', color: '#091057' }}>Products</div>
              <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: '#024CAA' }}>
                By kitchen
              </div>
            </div>
          </button>
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          {canAccessRoute('/teams', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('teams');
              RedirectPage('teams');
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <GroupsIcon style={{ color: '#EC8305', fontSize: '30px' }} />
              <div style={{ fontSize: '14px', fontFamily: 'Inter Bold', color: '#091057' }}>Teams</div>
              <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: '#024CAA' }}>
                Branch roster
              </div>
            </div>
          </button>
          )}

          {canAccessRoute('/squads', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('squads');
              RedirectPage('squads');
            }}
          >
            {'Team squads'}
          </button>
          )}

          {canAccessRoute('/analytics', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('analytics');
              RedirectPage('analytics');
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <AnalyticsOutlinedIcon style={{ color: '#EC8305', fontSize: '30px' }} />
              <div style={{ fontSize: '14px', fontFamily: 'Inter Bold', color: '#091057' }}>
                Analytics
              </div>
              <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: '#024CAA' }}>
                Zipcode insights
              </div>
            </div>
          </button>
          )}

          {canAccessRoute('/storeleads', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('storeleads');
              RedirectPage('storeleads');
            }}
          >
            {'Store Leads'}
          </button>
          )}

          {canAccessRoute('/zipcodemap', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('zipcodemap');
              RedirectPage('zipcodemap');
            }}
          >
            {'Zipcode Map'}
          </button>
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}>
          {canAccessRoute('/productagent', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('agentproduct');
              RedirectPage('agentproduct');
            }}
          >
            {'Ai Agent Product'}
          </button>
          )}
          {canAccessRoute('/logoagent', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('agentlogo');
              RedirectPage('agentlogo');
            }}
          >
            {'Ai Agent Logo'}
          </button>
          )}
          {canAccessRoute('/marketinglead', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('marketinglead');
              RedirectPage('marketinglead');
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CampaignRoundedIcon style={{ color: '#EC8305', fontSize: '30px' }} />
              <div style={{ fontSize: '14px', fontFamily: 'Inter Bold', color: '#091057' }}>
                Marketing Lead
              </div>
              <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: '#024CAA' }}>
                Zip filtered list
              </div>
            </div>
          </button>
          )}

          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('adlibrary');
              RedirectPage('adlibrary');
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CollectionsBookmarkOutlinedIcon style={{ color: '#EC8305', fontSize: '30px' }} />
              <div style={{ fontSize: '14px', fontFamily: 'Inter Bold', color: '#091057' }}>
                Ad Library
              </div>
              <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: '#024CAA' }}>
                Creatives &amp; tools
              </div>
            </div>
          </button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }}>
          {canAccessRoute('/servermonitoring', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('server-monitoring');
              RedirectPage('server-monitoring');
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <DnsOutlinedIcon style={{ color: '#EC8305', fontSize: '30px' }} />
              <div style={{ fontSize: '14px', fontFamily: 'Inter Bold', color: '#091057' }}>
                Server Monitoring
              </div>
              <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: '#024CAA' }}>
                Branch infrastructure
              </div>
            </div>
          </button>
          )}

          {canAccessRoute('/notifications', regBranchSession) && (
          <button
            style={BtnSelectedStyle}
            onClick={() => {
              setSelectedMenuTab('notifications');
              RedirectPage('notifications');
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <NotificationsActiveOutlinedIcon style={{ color: '#EC8305', fontSize: '30px' }} />
              <div style={{ fontSize: '14px', fontFamily: 'Inter Bold', color: '#091057' }}>
                Notifications
              </div>
              <div style={{ fontSize: '12px', fontFamily: 'Inter Regular', color: '#024CAA' }}>
                Expo push to users
              </div>
            </div>
          </button>
          )}
        </div>
      </div>
    </>
  );
};

export default DashBoard;
